import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getLabels({ commit }, { paginate, query }) {
        commit('LOAD_LABELS_REQUEST')

        return axios
            .get(`/labels/labels${paginate}${query}`)
            .then(response => {
                commit('LOAD_LABELS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('LOAD_LABELS_FAILURE')
                handleApiError(error, 'Pobranie listy etykiet nie powiodło się.')

                return Promise.reject(error)
            })
    },

    getLabel(context, labelId) {
        return axios
            .get(`/labels/labels/${labelId}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, `Pobranie danych do etykiety ${labelId} nie powiodło się.`)

                return Promise.reject(error)
            })
    },

    createLabel({ commit }, labelData) {

        return axios
            .post('/labels/labels', labelData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Etykieta została dodana.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Zapis nie powiódł się.')

                return Promise.reject(error)
            })
    },

    updateLabel({ commit }, labelData) {
        return axios
            .put(`/labels/labels/${labelData.id}`, labelData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Etykieta została zedytowana.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Zapis nie powiódł się.')

                return Promise.reject(error)
            })
    },

    deleteLabel({ commit }, labelId) {
        return axios
            .delete(`/labels/labels/${labelId}`)
            .then(response => {
                commit('DELETE_LABEL_SUCCESS', labelId)
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Etykieta została usunięta.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie etykiety nie powiodło się.')

                return Promise.reject(error)
            })
    },

    printLabel(context, printingDivisionIds) {
        return axios
            .post('/labels/print', {
                printingDivisionIds: printingDivisionIds
            }, {
                responseType: 'arraybuffer'
            })
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wygenerowanie etykiety nie powiodło się.')

                return Promise.reject(error)
            })
    },

    getProducts({ commit }) {
        return axios
            .get('/products/product-types')
            .then(response => {
                commit('LOAD_PRODUCTS_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie listy produktów nie powiodło się.')

                return Promise.reject(error)
            })
    },

    setLabelsFilters({ commit }, filters) {
        commit('SET_LABELS_FILTERS', filters)
    },
    clearLabelsFilters({ commit }) {
        commit('CLEAR_LABELS_FILTERS')
    }
}
